export default "__VITE_ASSET__BY1Hq2ar__"